import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import useStyles from "./style";
import { Button, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

import Uploadfiles from "./UploadFiles";
import ViewFiles from "./ViewFiles";

//Apis
import driverApi from "Services/Driver";

const Documents = ({ driverId , setsubmitButton , setSkipButton }) => {
  const classes = useStyles();
  const intl = useIntl();
  const t = intl.formatMessage;
  const dispatch = useDispatch();

  useEffect(() => {
    setsubmitButton(true);
    setSkipButton(true);
  }, [setsubmitButton, setSkipButton]);

  const [row, setRow] = useState([]);

  const [uploadFilesModal, setUploadFilesModal] = useState(false);
  const [viewFilesModal, setViewFilesModal] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [documentData, setDocumentData] = useState(null);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsInitialData, setDocumentsInitialData] = useState([]);
  
  const handleOpenUploadFilesModal = (row) => {
    console.log(row)
    setDocumentId(row?.documentId);
    setDocumentData(row);
    setUploadFilesModal(true);
  };

  const handleCloseUploadFilesModal = () => {
    getDriverDocuments();
    setDocumentData(null);
    setUploadFilesModal(false);
  };

  const handleCloseViewFilesModal = () => {
    getDriverDocuments();
    setDocumentData(null);
    setViewFilesModal(false);
  };

  const handleUploadDocument = (file) => {
    if (!documentData || !file || !driverId) {
      return Promise.reject(new Error("Missing driver document context"));
    }

    dispatch(showLoader(t({ id: "driver.loading" })));

    const formData = new FormData();
    formData.append("image", file);
    formData.append("driver_id", driverId);
    formData.append("document_type_id", documentData.documentId);

    const onSuccess = (res) => {
      dispatch(hideLoader());

      if (res?.status === 200 || res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || t({ id: "driver.docs.uploadSuccess" }),
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
      }

      return res;
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.docs.uploadError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      return Promise.reject(err);
    };

    return driverApi.updateDriverDocument(formData).then(onSuccess).catch(onFailure);
  };

  // View modal
  const handleOpenViewFilesModal = (row) => {
    setDocumentId(row?.documentId);
    setDocumentData(row);
    setViewFilesModal(true);
  };

  //Get documents

  const getDriverDocumentsTypes = () => {
    dispatch(showLoader(t({ id: "driver.loading" })));
  
    const onSuccess = (res) => {
      dispatch(hideLoader());
  
      if (res?.status === 200) {
        console.log("==========",res?.data?.data);
        const documentTypes = Array.isArray(res?.data?.data)
          ? res?.data?.data
          : Array.isArray(res?.data?.data?.data)
          ? res?.data?.data?.data
          : [];

        setDocumentsInitialData(documentTypes);
     
      }
    };
  
    const onFailure = (err) => {
      dispatch(hideLoader());
  
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.fetchError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
  
      console.log("error fetch service area", err);
    };
  
    driverApi.getDocumentsTypes().then(onSuccess).catch(onFailure);
  };

  const getDriverDocuments = () => {
   
    dispatch(showLoader(t({ id: "driver.loading" })));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
   setDriverDocumentsData(res?.data?.data?.driverDocuments);
 
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.fetchError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };

    if (validation) {
      driverApi
        .getDriverDocumentsByDriverId(driverId)
        .then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    getDriverDocumentsTypes();
    getDriverDocuments();
  }, []);
  // Handle driver delete document

  const handleDeleteDocument = (row) => {

    var result = window.confirm(t({ id: "driver.docs.confirmDelete" }));
    if (result) {
      dispatch(showLoader(t({ id: "driver.loading" })));
   
      let data = {
        document_type_id:row?.documentId,
        user_id:driverId,
      }
    
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          dispatch(
            showSnackbar({
              message: t({ id: "driver.docs.deleteSuccess" }),
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            })
          );
        }
        getDriverDocuments();
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        showSnackbar({
          message: t({ id: "driver.docs.deleteError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        });
      };
  
      driverApi.deleteDriverDocument({ ...data }).then(onSuccess, onFailure);
    }
  };


  useEffect(() => {
   

    const documentTypes = Array.isArray(documentsInitialData)
      ? documentsInitialData
      : [];

    const uploadedDocuments = Array.isArray(driverDocumentsData)
      ? driverDocumentsData
      : [];

    const combinedArray = documentTypes.map((item1) => {
      const matchingDocument = uploadedDocuments.find((item2) => {
        return item1.documentTypeAlias === item2.documentDescription;
      });

      const documentId = item1.id ?? 0;
      const documentPath = matchingDocument
        ? matchingDocument.documentPath ? matchingDocument.documentPath : ""
        : "";
      const status = matchingDocument
        ? matchingDocument.documentPath ? matchingDocument.status : t({ id: "driver.docs.noDocument" })
        : t({ id: "driver.docs.noDocument" });
       
      return {
        ...item1,
        documentId,
        file: documentPath,
        status,
      };
    });
    setRow(combinedArray);
  }, [driverDocumentsData, documentsInitialData]);

  const dataRows = _.map(row || [], (data, index) => ({
    id: index + 1,
    sno: index + 1,
    documentId: data?.documentId,
    documentType: data?.documentType,
    documentTypeAlias: data?.documentTypeAlias,
    file: data?.file,
    status: data?.status,
    data:data
  }));
  console.log(dataRows)

// useEffect(() => {
//   const allApproved = _.every(row, (doc) => doc?.status === "APPROVED");

//   setsubmitButton(allApproved);
//   setSkipButton(allApproved);
// }, [row]);


  const columns = [
    {
      field: "sno",
      headerName: t({ id: "driver.docs.sNo" }),
      minWidth: 180,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "documentType",
      headerName: t({ id: "driver.docs.type" }),
      minWidth: 200,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">
                {params?.row?.documentType}
              </Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: t({ id: "driver.docs.status" }),
      minWidth: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: t({ id: "driver.docs.action" }),
      minWidth: 320,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.actionBtnWrapper}>
            {params?.row?.file == "" && (
              <section className={classes.uploadButton}>
                <Button
                  variant="contained"
                  style={{ fontSize: "13px", borderRadius: "8px" }}
                  onClick={() => handleOpenUploadFilesModal(params?.row)}
                >
                  {t({ id: "driver.docs.upload" })}
                </Button>
              </section>
            )}
              {params?.row?.file != "" && (
                <>
                  <section className={classes.viewButton}>
                    <Button
                      variant="outlined"
                      style={{ fontSize: "13px", borderRadius: "8px" }}
                      onClick={() => handleOpenViewFilesModal(params?.row)}
                    >
                      {t({ id: "driver.docs.view" })}
                    </Button>
                  </section>

                  <section className={classes.deleteButton}>
                    <Button
                      variant="contained"
                      style={{ fontSize: "13px", borderRadius: "8px" }}
                      onClick={() => handleDeleteDocument(params?.row)}
                    >
                      {t({ id: "driver.docs.delete" })}
                    </Button>
                  </section>
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              rows={dataRows}
              columns={columns}
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
            />
          </section>
        </Grid>
      <Uploadfiles
        openDialog={uploadFilesModal}
        handleClose={handleCloseUploadFilesModal}
        onUploadDocument={handleUploadDocument}
      />
      <ViewFiles
        openDialog={viewFilesModal}
        handleClose={handleCloseViewFilesModal}
        driverId={driverId}
          documentId={documentId}
          documentData={documentData}
        ></ViewFiles>
      </Grid>
    </>
  );
};

export default Documents;
